import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RecentResourceItem {
  id: string;
  name: string;
  scope: string;
  folderPath: string;
  fileName: string;
  mimeType?: string | null;
  openedAt: number;
}

export interface RecentResourcesState {
  itemsByUser: Record<string, RecentResourceItem[]>;
}

const initialState: RecentResourcesState = {
  itemsByUser: {},
};

const MAX_ITEMS = 12;

const recentResourcesSlice = createSlice({
  name: 'recentResources',
  initialState,
  reducers: {
    addRecentResource: (
      state,
      action: PayloadAction<{ userId: string; item: Omit<RecentResourceItem, 'openedAt'> }>
    ) => {
      const userId = action.payload.userId;
      if (!userId) return;

      const now = Date.now();
      const nextItem: RecentResourceItem = {
        ...action.payload.item,
        openedAt: now,
      };

      const current = state.itemsByUser[userId] || [];
      const deduped = current.filter((it: any) => {
        const scope = it && it.scope ? String(it.scope) : '';
        const fileName = it && (it.fileName || it.name) ? String(it.fileName || it.name) : '';
        const folderPath = it && it.folderPath ? String(it.folderPath) : '';
        return !(scope === nextItem.scope && fileName === nextItem.fileName && folderPath === nextItem.folderPath);
      });
      state.itemsByUser[userId] = [nextItem, ...deduped].slice(0, MAX_ITEMS);
    },
    clearRecentResources: (state, action: PayloadAction<{ userId: string }>) => {
      const userId = action.payload.userId;
      if (!userId) return;
      state.itemsByUser[userId] = [];
    },
  },
});

export const { addRecentResource, clearRecentResources } = recentResourcesSlice.actions;
export default recentResourcesSlice.reducer;
